import { encodeBase64, encodeHex } from "#staxmpc/lib/encode";
import init, { genInstanceId, KeygenSetupBuilder, SignSetupBuilder } from "@stavax/schnorr-wasm";
import wasmUrl from "@stavax/schnorr-wasm/schnorr_wasm_bg.wasm?url";
export const dklsLoader = init(wasmUrl);
export var SignAlgo = /* @__PURE__ */ ((SignAlgo2) => {
  SignAlgo2["ECDSA"] = "ecdsa";
  SignAlgo2["EdDSA"] = "eddsa";
  return SignAlgo2;
})(SignAlgo || {});
const ENC_KEY_TAG = 74;
export class MPCClient {
  config;
  constructor(config) {
    this.config = config;
  }
  async startDkg(signAlgo, instance, msg) {
    return await this.callAPI(`/mpc/${signAlgo}/keygen`, instance, void 0, msg);
  }
  async startDsg(signAlgo, instance, keyId, msg) {
    return await this.callAPI(`/mpc/${signAlgo}/signgen`, instance, keyId, msg);
  }
  createKeygenSetup(signAlgo, clients, threshold, ttl = 10) {
    const instance = genInstanceId();
    const builder = new KeygenSetupBuilder();
    if (signAlgo == "ecdsa" /* ECDSA */) {
      clients.forEach((n) => builder.addParty(n.verifyingKey, 0));
      builder.addParty(this.config.server.verifyingKey, 0);
    } else if (signAlgo === "eddsa" /* EdDSA */) {
      clients.forEach((n) => {
        builder.addParty(n.verifyingKey, 0);
        builder.addTag(ENC_KEY_TAG, n.encryptionKey);
      });
      builder.addParty(this.config.server.verifyingKey, 0);
      builder.addTag(ENC_KEY_TAG, this.config.server.encryptionKey);
    } else {
      throw new Error("invalid signAlgo");
    }
    const setup = builder.build(
      instance,
      ttl,
      threshold,
      this.config.setup.secretKey
    );
    return { setup, instance };
  }
  createSignSetup(partyPublicKeys, keyId, message, ttl = 10, tags) {
    const instance = genInstanceId();
    const builder = new SignSetupBuilder(keyId);
    partyPublicKeys.forEach((k) => builder.addParty(k));
    let msgToSign = void 0;
    if (message) {
      if (message.sha256) {
        msgToSign = message.sha256;
        builder.withHashSha256(msgToSign);
      } else if (message.sha256D) {
        msgToSign = message.sha256D;
        builder.withHashSha256d(msgToSign);
      } else if (message.keccak256) {
        msgToSign = message.keccak256;
        builder.withHashKeccak256(msgToSign);
      } else if (message.hash) {
        msgToSign = message.hash;
        builder.withHash(msgToSign);
      } else {
        throw new Error("missing message");
      }
    }
    if (!msgToSign) {
      throw new Error("missing message");
    }
    tags?.forEach(({ tag, value }) => builder.addTag(tag, value));
    const setup = builder.build(
      instance,
      ttl,
      this.config.setup.secretKey
    );
    return { setup, instance };
  }
  async callAPI(path, instance, keyId, msg) {
    const body = {
      instance: encodeBase64(instance)
    };
    if (msg) {
      body.msg = encodeBase64(msg);
    }
    if (keyId) {
      body.key_id = encodeHex(keyId);
    }
    const accessToken = localStorage.getItem(this.config.accessTokenKey);
    const url = `${this.config.server.endpoint}${path}`;
    const resp = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...accessToken ? { "Authorization": `Bearer ${accessToken}` } : {}
      },
      body: JSON.stringify(body)
    });
    if (resp.status != 200) {
      console.log("resp status", url, resp.status, await resp.text());
      throw new Error("status " + resp.status);
    }
    return resp.json();
  }
}
export function randomSeed(count = 32) {
  return window.crypto.getRandomValues(new Uint8Array(count));
}
